import type { ReactElement } from 'react'
import { useMemo } from 'react'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { asArray, EmptyArray } from 'lib/array/arrayUtils'

interface Props {
  title?: string
  dates?: string | false
  metaData?: ReactElement | false
  occupancy?: string | false
  roomName?: string
  packageTitle?: string | Array<string>
}

function CondensedCartReviewTileContent(props: Props) {
  const {
    title,
    dates,
    packageTitle = EmptyArray,
    metaData,
    occupancy,
    roomName,
  }: Props = props

  const packageTitles = useMemo(() => asArray(packageTitle), [packageTitle])

  return <div>
    {(title && dates) && <Group direction="vertical" gap={4}>
      <Heading variant="heading6" lineClamp={2}>{title}</Heading>
      <BodyText variant="medium" colour="light-foreground-alt">{dates}</BodyText>
    </Group>}
    <Group direction="vertical" gap={2}>
      {roomName && <BodyText variant="medium" colour="light-foreground-alt">{roomName}</BodyText>}
      {!roomName && packageTitles.map((packageTitle) => <BodyText
        key={packageTitle}
        variant="medium"
        colour="light-foreground-alt"
        lineClamp={2}
      >
        {packageTitle}
      </BodyText>)}
      {metaData}
      {!!occupancy && <BodyText variant="medium" colour="light-foreground-alt">{occupancy}</BodyText>}
    </Group>
  </div>
}

export default CondensedCartReviewTileContent
